<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XZSV3G/tc-custom/9781426842009.jpg?1728724861146" alt="This image is the cover for the book Sicilian Marriage, The O'Connells"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sicilian Marriage, The O'Connells
      </h1>
      <p class="bookDescription body article font2">
        <b>A Sicilian courtship:</b><br/><br/>Fast and furious—the sex was fantastic. But Briana O'Connell's explosive encounter with wealthy Sicilian Gianni Firelli was just for the moment, not a lifetime—wasn't it?<br/><br/><b>The Sicilian marriage:</b>Formal and forever—Gianni has news for Briana: the tragedy that had brought them together in grief-fulled passion had also resulted in their both being named as joint guardians of a baby girl—for whose sake, Gianni insisted, they must marry!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sandra Marton
      </h2>
      
      <p class="authorDescription body article">Sandra Marton is a USA Todday Bestselling Author. A four-time finalist for the RITA, the coveted award given by Romance Writers of America, she&#39;s also won eight Romantic Times &#160;Reviewers&rsquo; Choice Awards, the Holt Medallion, and Romantic Times&rsquo; Career Achievement Award. Sandra&#39;s heroes are powerful, sexy, take-charge men who think they have it all--until that one special woman comes along. Stand back, because together they&#39;re bound to set the world on fire.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?681c33c6